var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: "", shrink: "" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("general")))]),
      _c(
        "w-list",
        [
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$ct("point-out")) + " "),
                  _c("span", { staticClass: "last-executed-date" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getLastExecutedText(
                            _vm.currentBookYearObj.LastAfpuntenSales
                          )
                        )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _vm.afpuntenRunning
                    ? _c("w-progress-circular", { attrs: { small: "" } })
                    : _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.afpunten()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("saldos-overboeken-from-year-to-year", {
                        currentBookYear: _vm.currentBookYear,
                        newerBookYear: _vm.newerBookYear,
                      })
                    ) + " "
                  ),
                  _c("span", { staticClass: "last-executed-date" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getLastExecutedText(
                            _vm.currentBookYearObj.LastCopyOpenSales
                          )
                        )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _vm.saldosOverboekenRunning
                    ? _c("w-progress-circular", { attrs: { small: "" } })
                    : _c(
                        "w-button",
                        {
                          attrs: { icon: "", disabled: !_vm.hasNewerBookYear },
                          on: {
                            click: function ($event) {
                              return _vm.saldosOverboeken()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$ct("purchase-point-out")) + " "),
                  _c("span", { staticClass: "last-executed-date" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getLastExecutedText(
                            _vm.currentBookYearObj.LastAfpuntenPurchases
                          )
                        )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _vm.purchaseAfpuntenRunning
                    ? _c("w-progress-circular", { attrs: { small: "" } })
                    : _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.purchaseAfpunten()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("purchase-saldos-overboeken", {
                        currentBookYear: _vm.currentBookYear,
                        newerBookYear: _vm.newerBookYear,
                      })
                    ) + " "
                  ),
                  _c("span", { staticClass: "last-executed-date" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getLastExecutedText(
                            _vm.currentBookYearObj.LastCopyOpenPurchases
                          )
                        )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _vm.purchaseSaldosOverboekenRunning
                    ? _c("w-progress-circular", { attrs: { small: "" } })
                    : _c(
                        "w-button",
                        {
                          attrs: { icon: "", disabled: !_vm.hasNewerBookYear },
                          on: {
                            click: function ($event) {
                              return _vm.purchaseSaldosOverboeken()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$ct("fill-ledgers-in-sale-rows")) + " "),
                  _c("span", { staticClass: "last-executed-date" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getLastExecutedText(
                            _vm.currentBookYearObj.LastFillLedgersInSaleDetail
                          )
                        )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _vm.fillLedgersRunning
                    ? _c("w-progress-circular", { attrs: { small: "" } })
                    : _c(
                        "w-button",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.fillLedgers()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.canDoIntraConsignment
            ? _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$ct("intra-consignment")) + " "),
                    ]),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openIntraConsignment()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$ct("create-vat-declaration")) + " "),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.openCreateVatDeclarationModal()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "play" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("copy-bank-saldos-to-newer-bookyear", {
                        newerBookYear: _vm.newerBookYear,
                      })
                    ) + " "
                  ),
                  _c("span", { staticClass: "last-executed-date" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getLastExecutedText(
                            _vm.currentBookYearObj
                              .LastBeginBankCreateInNewBookyear
                          )
                        )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _vm.copyBankSaldosRunning
                    ? _c("w-progress-circular", { attrs: { small: "" } })
                    : _c(
                        "w-button",
                        {
                          attrs: { disabled: !_vm.hasNewerBookYear },
                          on: {
                            click: function ($event) {
                              return _vm.copyBankSaldos()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$ct("common.job-name.recompute-contact-stats"))
                  ),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _vm.recomputeContactStatsRunning
                    ? _c("w-progress-circular", { attrs: { small: "" } })
                    : _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.recomputeContactStatsClicked()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.intraConsignmentModal,
            callback: function ($$v) {
              _vm.intraConsignmentModal = $$v
            },
            expression: "intraConsignmentModal",
          },
        },
        [
          _c("app-accounting-intra-consignment-modal", {
            on: {
              close: function ($event) {
                _vm.intraConsignmentModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.vatDeclarationModal,
            callback: function ($$v) {
              _vm.vatDeclarationModal = $$v
            },
            expression: "vatDeclarationModal",
          },
        },
        [
          _c("app-craate-vat-declaration-modal", {
            on: {
              close: function ($event) {
                _vm.vatDeclarationModal = false
              },
            },
          }),
        ],
        1
      ),
      _vm.recomputeContactStatsModal
        ? _c("AppMultiSelectBookYearModal", {
            on: {
              close: function ($event) {
                _vm.recomputeContactStatsModal = false
              },
              confirm: function ($event) {
                return _vm.recomputeContactStats($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }